export const EVENT_CACHE_LOCAL_STORAGE_KEY = 'reelflow_events';
